<template>
  <AppView :title="pageTitle" :backable="true" :deskHeader="false">
    <main
      data-desktop-procedure
      class="min-w-0 bg-white desk:min-h-0 desk:flex-1"
    >
      <div
        class="min-w-0 desk:grid desk:min-h-[calc(100vh-3.5rem)] desk:grid-cols-2 desk:items-stretch"
      >
        <section
          class="hidden desk:block desk:border-r desk:border-gray-100"
        >
          <div class="desk:sticky desk:top-14 desk:px-12 desk:py-10">
            <p class="text-xs font-medium text-gray-400 desk:text-dove-gray">幫助</p>
            <h1 class="mt-2 text-3xl font-bold text-gray-900">{{ pageTitle }}</h1>
            <p class="mt-3 text-sm leading-6 text-gray-500">
              依步驟完成註冊與購買。說明由系統文件提供。
            </p>
          </div>
        </section>

        <section class="p-5 desk:px-12 desk:py-10">
          <div
            v-if="content"
            class="prose max-w-none break-words text-sm text-chicago desk:leading-7"
            v-html="content"
          />
          <img
            v-else-if="imgs.procedure && !imgFailed"
            :src="imgs.procedure"
            alt=""
            class="w-full desk:mx-auto desk:block desk:h-auto desk:max-w-[520px]"
            @error="imgFailed = true"
          />
          <p
            v-else
            class="py-10 text-center text-sm text-gray-400 desk:py-0 desk:text-left"
          >
            暫無購買流程說明
          </p>
        </section>
      </div>
    </main>
  </AppView>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  auth: false,
  data() {
    return {
      imgFailed: false,
    };
  },
  head() {
    const appName = this.$store.getters["app/info"]?.name || process.env.APP_NAME;
    const title = this.info?.docs?.procedure?.title || "購買流程";
    return {
      title: `${appName}-${title}`,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: `${appName},${appName}-${title}`,
        },
        {
          hid: "description",
          name: "description",
          content: `${appName}${title}幫助您在本平台進行愉快的購物。`,
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: `${appName}-${title}`,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: appName,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}/procedure`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: `${process.env.APP_NAME}${title}幫助您在本平台進行愉快的購物。`,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: `${process.env.APP_URL}/static/icon.png`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      imgs: "app/imgs",
      info: "app/info",
    }),
    pageTitle() {
      return this.info?.docs?.procedure?.title || "購買流程";
    },
    content() {
      return this.info?.docs?.procedure?.content || "";
    },
  },
};
</script>

<style scoped>
.prose >>> img {
  width: 100%;
  height: auto;
}
</style>
